<!-- features-by-tiers.component.html -->
<div class="w-full h-full">
    <app-tab-header [tabs]="tabs"></app-tab-header>

    <!-- ── Top bar ─────────────────────────────────────────────────────────── -->
    <ng-container *ngIf="getAdminButtonState() as btnState">
        <div *ngIf="!btnState.disabled" class="px-5 pt-5 pb-3 flex items-center justify-between mb-2">
            <!-- Left: create button -->
            <div class="flex items-center gap-4">
                    <button
                        (click)="openCreateDialog()"
                        class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-5 py-3"
                    >
                        Add Feature
                    </button>
                </div>
            </div>
    </ng-container>

    <!-- ── Data Table ──────────────────────────────────────────────────────── -->
    <div class="px-5">
        <div class="bg-light-orange" style="border-left: 1px solid #CAC2BC; border-right: 1px solid #CAC2BC;">

            <app-data-table
                [tableSubHeader]="tableSubHeader"
                [isLoading]="isLoading"
                [centeredContent]="true"
            >

                <!-- ── Rows ── -->
                <tr *ngFor="let feature of featureList" class="focus:outline-none">

                    <!-- Feature Name -->
                    <td class="text-center text-xs">
                        {{ feature.featureName | nullWithDefault }}
                    </td>

                    <td
                        *ngFor="let tier of tierColumns"
                        class="text-center text-xs"
                    >
                        {{ getTierAccess(feature, tier.tierId) }}
                    </td>

                    <!-- ── Actions ── -->
                    <td class="text-center">
                        <div class="flex items-center justify-center gap-1">
                            <ng-container *ngIf="getAdminButtonState() as btnState">

                                <!-- ══════════════════════════════════════════════════════
                                    ADMIN VIEW: Edit + Enable/Disable toggle
                                ══════════════════════════════════════════════════════ -->
                                <ng-container *ngIf="!btnState.disabled; else nonAdminActions">

                                    <!-- Edit -->
                                    <button
                                        class="custom-btn focus:outline-none"
                                        style="width:54px; height:23px; border-radius:5px; color:#fff;
                                            background:#3374b7; font-size:10px; font-weight:600;"
                                        (click)="openEditDialog(feature)"
                                    >
                                        Edit
                                    </button>

                                    <!-- status === 0 → Enabled (green) -->
                                    <button
                                        *ngIf="feature.status === 0"
                                        class="custom-btn power-btn2 active focus:outline-none"
                                        style="width:68px; height:23px; font-size:10px;"
                                        (click)="toggleStatusConfirmation(feature)"
                                    >
                                        Enabled
                                    </button>

                                    <!-- status === 1 → Disabled (red) -->
                                    <button
                                        *ngIf="feature.status === 1"
                                        class="custom-btn power-btn2 focus:outline-none"
                                        style="width:68px; height:23px; font-size:10px;"
                                        (click)="toggleStatusConfirmation(feature)"
                                    >
                                        Disabled
                                    </button>

                                </ng-container>

                                <!-- ══════════════════════════════════════════════════════
                                    NON-ADMIN VIEW: No Edit button.
                                    Show a visually disabled, non-interactive toggle only.
                                ══════════════════════════════════════════════════════ -->
                                <ng-template #nonAdminActions>

                                    <!-- status === 0 → Enabled (green, disabled) -->
                                    <span
                                        *ngIf="feature.status === 0"
                                        [matTooltip]="btnState.tooltip"
                                        matTooltipClass="custom-orange-tooltip"
                                        matTooltipPosition="left"
                                        style="display: inline-block; cursor: not-allowed;"
                                    >
                                        <button
                                            class="custom-btn power-btn2 active focus:outline-none"
                                            style="width:68px; height:23px; font-size:10px;
                                                opacity:0.4; pointer-events:none;"
                                            disabled
                                        >
                                            Enabled
                                        </button>
                                    </span>

                                    <!-- status === 1 → Disabled (red, disabled) -->
                                    <span
                                        *ngIf="feature.status === 1"
                                        [matTooltip]="btnState.tooltip"
                                        matTooltipClass="custom-orange-tooltip"
                                        matTooltipPosition="left"
                                        style="display: inline-block; cursor: not-allowed;"
                                    >
                                        <button
                                            class="custom-btn power-btn2 focus:outline-none"
                                            style="width:68px; height:23px; font-size:10px;
                                                opacity:0.4; pointer-events:none;"
                                            disabled
                                        >
                                            Disabled
                                        </button>
                                    </span>

                                </ng-template>

                            </ng-container>
                        </div>
                    </td>

                </tr>

                <!-- ── Empty state ── -->
                <tr *ngIf="!isLoading && featureList.length === 0">
                    <td [attr.colspan]="tableSubHeader.length"
                        class="text-center py-4 h-250-px text-gray-500 italic text-xs">
                        No tier features found.
                    </td>
                </tr>

            </app-data-table>
        </div>
    </div>

    <!-- ── Footer: showing text only ───────────────────────────────────────── -->
    <div class="px-5 py-3">
        <span class="text-xs font-semibold" style="color: #E07B39;">
            {{ showingText }}
        </span>
    </div>

</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>